import { useEffect } from "react";

const TypeFormEmbed: React.FC = () => {
  useEffect(() => {
    const script = document.createElement("script");
    script.src = "//embed.typeform.com/next/embed.js";
    script.async = true;
    document.body.appendChild(script);

    return () => {
      document.body.removeChild(script);
    };
  }, []);

  return (
    <div
      data-tf-live="01JN1S7TH3DAHWXQBXAHQAJ4Y1"
      className="w-full h-[500px]"
    ></div>
  );
};

export default TypeFormEmbed;
